import React from "react";
import { matchPath } from "react-router-dom";
import type { GeneratedPageDataConfig } from "./dataSource";

export interface GeneratedPageProps {
  data?: any;
}

export interface GeneratedPageRoute {
  pageId: string;
  routePath: string;
  Component: React.LazyExoticComponent<React.ComponentType<GeneratedPageProps>>;
  data?: GeneratedPageDataConfig;
}

// callouts 公开数据 ZIP 上传后的 CDN 根目录（见 crawler/map/data/5/public_data_package.json）
// 数据 JSON 路径：{CALLOUTS_DATA_BASE}data/{version}/cs2util/{category}.json
export const CALLOUTS_DATA_BASE = "https://fileserver.cdn.huya.com/game_tile_zip/54a7a81a4bea45b98104611c068ba8af/";
const CALLOUTS_DATA_VERSION = "5";

export const calloutsDataUrl = (category: string) =>
  `${CALLOUTS_DATA_BASE}data/${CALLOUTS_DATA_VERSION}/cs2util/${category}.json`;

// 列表首屏只需 list 一个 JSON 即可渲染卡片网格；
// 各地图 detail_{slug} 由详情页组件进入时按需 fetch（懒加载），避免 9 个 JSON 全量阻塞首屏。
const calloutsDataKeys = [calloutsDataUrl("list")];

export const generatedPageRegistry: GeneratedPageRoute[] = [
  {
    pageId: "callouts",
    routePath: "/callouts",
    Component: React.lazy(() => import("./callouts")),
    data: {
      // 默认 remote（消费 CDN 真实数据）；?mock=1 可切回 mock 骨架验证
      defaultSource: "remote",
      dataKeys: calloutsDataKeys,
      // list.json 加载期间透传渲染组件，由 callouts 自行渲染卡片骨架屏，避免首屏白屏
      loadingPassthrough: true,
      mockLoader: async () => {
        const module = await import("./callouts/mock");
        return module.default;
      },
    },
  },
];

export const normalizeRoutePath = (routePath: string) => {
  if (!routePath || routePath === "/") {
    return "/";
  }

  const normalized = routePath.replace(/\/+/g, "/").replace(/\/$/, "");

  return normalized.startsWith("/") ? normalized : `/${normalized}`;
};

export const resolveGeneratedPage = (pathname: string) => {
  const normalizedPath = normalizeRoutePath(pathname);

  return generatedPageRegistry.find(route =>
    Boolean(matchPath({ path: normalizeRoutePath(route.routePath), end: false }, normalizedPath)),
  );
};
